// /web/src/pages/HowTo.jsx
import React from "react";

const steps = [
  {
    title: "Frame the brief",
    detail: "Start with location, mix, areas and floor heights. Pebbledash normalises the data so every calculator stays aligned.",
  },
  {
    title: "Run calculators",
    detail: "Choose the tools you need—lift traffic, WC provision, risers, end-of-trip, envelope—and adjust assumptions in seconds.",
  },
  {
    title: "Share & export",
    detail: "Export diagrams and schedules or invite teammates to collaborate directly so you always have a shared source of truth.",
  },
];

export default function HowToPage() {
  return (
    <div>
      <section className="pd-section" aria-labelledby="howto-hero">
        <div className="pd-container" style={{ maxWidth: "840px" }}>
          <p className="pd-eyebrow">How-to</p>
          <h1 id="howto-hero" className="pd-display">
            A consistent workflow from input to export
          </h1>
          <p className="pd-lead">
            Use Pebbledash to capture the essentials, test options quickly and hand clients evidence-backed recommendations.
          </p>
        </div>
      </section>

      <section className="pd-section pd-section--tint-navy" aria-labelledby="howto-steps">
        <div className="pd-container">
          <h2 id="howto-steps" className="pd-h2">
            Three steps to clarity
          </h2>
          <ol className="pd-steps--media">
            {steps.map((step, index) => (
              <li key={step.title} className="pd-step--media">
                <div className="pd-step__text">
                  <span className="pd-step__num">{`0${index + 1}`}</span>
                  <div>
                    <h3 className="pd-h3">{step.title}</h3>
                    <p className="pd-muted">{step.detail}</p>
                  </div>
                </div>
                <div className="pd-step__media" aria-hidden="true">
                  <div className="pd-media-placeholder">Media Placeholder</div>
                </div>
              </li>
            ))}
          </ol>
        </div>
      </section>
    </div>
  );
}
